import React, { useEffect } from 'react';
import { styles } from '../../styles/theme';

const Modal = ({ isOpen, onClose, title, children, maxWidth = '600px' }) => {
  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={styles.modalOverlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{ ...styles.modalCard, maxWidth }}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>{title}</h2>
          <button
            style={styles.closeButton}
            onClick={onClose}
            onMouseOver={(e) => Object.assign(e.target.style, styles.closeButtonHover)}
            onMouseOut={(e) => Object.assign(e.target.style, styles.closeButton)}
            aria-label="Fechar"
          >
            X
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
